export const shuffle = (array) => array.sort(() => 0.5 - Math.random());
